import React, { lazy } from 'react';
// import axios from 'axios';
// import { message } from 'antd';
import { useSelector } from 'react-redux'; // useDispatch, 
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from 'react-router-dom'; // useHistory
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
// import { clearUserData } from '../../redux/CrmReduxCalls/LocalDataReduxStore';
// import { getBaseURL } from '../../Api/ApiConfig'

const Dashboard = lazy(() => import('../../container/dashboard'));
const Users = lazy(() => import('../../container/dashboard/Administration/Userlist'))
const UserHistory = lazy(() => import('../../container/dashboard/Administration/Us-LoginH'))
const Teams = lazy(() => import('../../container/dashboard/Administration/TeamList'))
const ProfilePage = lazy(() => import('../../container/dashboard/Administration/ProfilePage'))
const Task = lazy(() => import('../../container/dashboard/Pages/TaskList'))
const Deal = lazy(() => import('../../container/dashboard/Pages/DealsList'))
const Lead = lazy(() => import('../../container/dashboard/Pages/LeadsList'))
const Email = lazy(() => import('../../container/dashboard/Pages/EmailPage'))
const Meeting = lazy(() => import('../../container/dashboard/Pages/MeetingList'))
const Account = lazy(() => import('../../container/dashboard/Pages/AccountList'))
const contact = lazy(() => import('../../container/dashboard/Pages/ContactList'))
const Alltemplate = lazy(() => import('../../container/dashboard/Administration/EmailTemp'))
const AllCompanyrole = lazy(() => import('../../container/dashboard/Administration/CompanyRole'))
const Details = lazy(() => import('../../container/dashboard/Pages/DetailsPage/AllDetailPage'))
const Settings = lazy(() => import('../../container/dashboard/Administration/SettingsPage'))
const Notes = lazy(() => import('../../container/dashboard/note/Note'))
const Products = lazy(() => import('../../container/dashboard/Administration/ProductListing'))
const Notification = lazy(() => import('../../components/utilities/auth-info/notificationpage/NotificationPage'))
const EmailNotification = lazy(() => import('../../components/utilities/auth-info/notificationpage/EmailNotificationPage'))
const ReportListing = lazy(() => import('../../container/dashboard/Reports/ReportListing'))
const AddReports = lazy(() => import('../../container/dashboard/Reports/Reportindex'))
const Forecasting = lazy(() => import('../../container/dashboard/Forecasting/ForecastP1'))
const RolesListing = lazy(() => import('../../container/dashboard/Administration/AugRolesListing'))
const ServicesListing = lazy(() => import('../../container/dashboard/Administration/ServiceLineListing'))
const GoalsAndTargetListing = lazy(() => import('../../container/dashboard/Administration/GoalsAndTargetListing'))
const MyReporties = lazy(() => import('../../container/dashboard/Administration/MyRepGATPage'))
const AddGoalsAndTarget = lazy(() => import('../../container/dashboard/Administration/AddGATPage'))
const WeekdaysHolidaysList = lazy(() => import('../../container/dashboard/Administration/WeekdyHolidyList'))
const CurrencyPage = lazy(() => import('../../container/dashboard/Administration/CurrencyPage'))
const AiDataControl = lazy(() => import('../../container/dashboard/Administration/AIScope'))
const EmailConfig = lazy(() => import('../../container/dashboard/Administration/EmailConfigpage'))
const Automation = lazy(() => import('../../container/dashboard/AutomationRule/Index'))
const AutomationList = lazy(() => import('../../container/dashboard/AutomationRule/AutomationList'))
const Approval = lazy(() => import('../../container/dashboard/ApprovalProcess/Index'))
const ApprovalList = lazy(() => import('../../container/dashboard/ApprovalProcess/ApprovalList'))
const Assignment = lazy(() => import('../../container/dashboard/AssignmentRule/Index'))
const AssignmentList = lazy(() => import('../../container/dashboard/AssignmentRule/AssignmentList'))
const QuotesList = lazy(() => import('../../container/dashboard/QISC/QuotesLisitng'))
const SalesList = lazy(() => import('../../container/dashboard/QISC/OrderListing'))
const InvoicesList = lazy(() => import('../../container/dashboard/QISC/InvoiceListing'))
const CasesList = lazy(() => import('../../container/dashboard/QISC/CasesListing'))
const Subscription = lazy(() => import('../../container/dashboard/Subscription/index'))
const SubcripeStatus = lazy(() => import('../../container/dashboard/Subscription/SubcripeStatus'))
const Territory = lazy(() => import('../../container/dashboard/Administration/TerritotyList'))
const ApprovalQueue = lazy(() => import('../../container/dashboard/ApprovalProcess/ApprovalQueue'))
const CampaignListing = lazy(() => import('../../container/dashboard/QISC/CampaignListing'))
const ProductIntegration = lazy(() => import('../../container/dashboard/Administration/ProductIntegration'))
const Sequence = lazy(() => import('../../container/dashboard/Sequence/Index'))
const SequenceList = lazy(() => import('../../container/dashboard/Sequence/SequenceList'))
const SequenceQueue = lazy(() => import('../../container/dashboard/Sequence/SequenceQueue'))
const Customize = lazy(() => import('../../container/dashboard/CustomizeUi/index'))
const CustomizeDropdown = lazy(() => import('../../container/dashboard/CustomizeUi/DropdownList'))
const CustomizePipeline = lazy(() => import('../../container/dashboard/CustomizeUi/PipelineList'))
const SystemLog = lazy(() => import('../../container/dashboard/Administration/SystemLog'))
const NewReports = lazy(() => import('../../container/dashboard/Reports/CRMCharts1'))
// const CRMChatPage = lazy(() => import('../../container/dashboard/CrmChatPage/index'));

function PrivateRoute({ component: Component, allowedRoles, basePath, ...rest }) {
  const localData = useSelector((state) => state.localRedux);
  const rolesData = localData.role


  return (
    <Route
      {...rest}
      render={(props) =>
        allowedRoles.includes(rolesData) ? (
          <Component {...props} />
        ) : (
          <Redirect to={basePath} />
        )
      }
    />
  );
}
PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  basePath: PropTypes.string.isRequired,
};

const routesConfig = [
  { path: "/profile-page", component: ProfilePage, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/email/:page", component: Email, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/meetings", component: Meeting, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/accounts", component: Account, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/deals", component: Deal, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/leads", component: Lead, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/contacts", component: contact, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/tasks", component: Task, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/users", component: Users, roles: ["Administrator"] },
  { path: "/groups", component: Teams, roles: ["Administrator"] },
  { path: "/users-history", component: UserHistory, roles: ["Administrator"] },
  { path: "/email-templates", component: Alltemplate, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/company-roles", component: AllCompanyrole, roles: ["Administrator"] },
  { path: "/details", component: Details, roles: ["Super Admin", "Administrator", "Advanced User", "Basic User"] },
  { path: "/settings", component: Settings, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/notes", component: Notes, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/products", component: Products, roles: ["Administrator", "Advanced User"] },
  { path: "/notifications", component: Notification, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/email-notifications", component: EmailNotification, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/reports", component: ReportListing, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/custom-report", component: AddReports, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/forecast", component: Forecasting, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/staff-roles", component: RolesListing, roles: ["Administrator", "Advanced User"] },
  { path: "/serviceline", component: ServicesListing, roles: ["Administrator", "Advanced User"] },
  { path: "/goals-and-target", component: GoalsAndTargetListing, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/add-goals-and-target", component: AddGoalsAndTarget, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/working-days", component: WeekdaysHolidaysList, roles: ["Administrator"] },
  { path: "/multi-currency", component: CurrencyPage, roles: ["Administrator"] },
  { path: "/configure_RAG", component: AiDataControl, roles: ["Administrator"] },
  { path: "/email-config", component: EmailConfig, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/my-organization", component: MyReporties, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/add-automation-rule", component: Automation, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/automation-rules", component: AutomationList, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/add-assignment-rule", component: Assignment, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/assignment-rules", component: AssignmentList, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/add-approval-rule", component: Approval, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/approval-rules", component: ApprovalList, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/outreach-rules", component: SequenceList, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/add-outreach-rule", component: Sequence, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/system-log", component: SystemLog, roles: ["Administrator"] },
  { path: "/quotes", component: QuotesList, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/orders", component: SalesList, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/invoices", component: InvoicesList, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/cases", component: CasesList, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/campaigns", component: CampaignListing, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/subscription", component: Subscription, roles: ["Administrator"] },
  { path: "/territories", component: Territory, roles: ["Administrator"] },
  { path: "/approval-queue", component: ApprovalQueue, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/outreach-queue", component: SequenceQueue, roles: ["Administrator", "Advanced User", "Basic User"] },
  { path: "/product-integration", component: ProductIntegration, roles: ["Administrator"] },
  { path: "/subcription-status", component: SubcripeStatus, roles: ["Administrator"] },
  { path: "/customize-Form", component: Customize, roles: ["Administrator"] },
  { path: "/customize-dropdown", component: CustomizeDropdown, roles: ["Administrator"] },
  { path: "/customize-pipeline", component: CustomizePipeline, roles: ["Administrator"] },
  { path: "/newRports", component: NewReports, roles: ["Administrator", "Advanced User", "Basic User"] },
  // { path: "/chat", component: CRMChatPage, roles: ["Administrator", "Advanced User", "Basic User"] },
]

function DashboardRoutes() {
  const { path } = useRouteMatch();
  const localData = useSelector((state) => state.localRedux);
  const roles = localData.role

  return (
    <Switch>
      {roles !== "Super Admin" ? (
        <Route exact path={path} component={Dashboard} />
      ) : (
        <></>
      )}
      {routesConfig.map(({ path: subPath, component, roles }) => (
        <PrivateRoute
          key={subPath}
          path={`${path}${subPath}`}
          component={component}
          allowedRoles={roles}
          basePath={path}
        />
      ))}
      <Route render={() => <Redirect to={path} />} />
    </Switch>
  );
}

export default DashboardRoutes;

